import { WidgetType } from 'types/widget.types';

export const LIST_MIRROR_DISABLED = [
  WidgetType.Line,
  WidgetType.Table,
  WidgetType.PieChart,
  WidgetType.LineChart,
  WidgetType.ColumnChart,
  WidgetType.BarChart,
  WidgetType.StackedBarChart,
  WidgetType.StackedColumnChart,
  WidgetType.ProgressChart,
  WidgetType.StatChart,
  WidgetType.AreaChart,
  WidgetType.StackedAreaChart,
  WidgetType.QRCode,
  WidgetType.WordCloudChart,
  WidgetType.HistogramChart,
  WidgetType.MapChart,
  WidgetType.HalfPieChart,
  WidgetType.ComboChart,
  WidgetType.VideoEmbed,
  WidgetType.Lottie,
  WidgetType.MultipleChoices,
  WidgetType.FunnelChart,
  WidgetType.ScatterBubbleChart,
];
